import { RouteConfig } from 'vue-router';

import Login from '@/views/Login.vue';

export const loginRoute: RouteConfig = {
  path: '/login',
  name: 'login',
  component: Login
};
